<template>
  <div :style="'height:' + (store.state.windowHeight - 140) + 'px'" @click="handlePageClick">
    <el-form :model="obj">
      <div class='columns'>
        <el-space wrap>
          <el-form-item label="">
            <el-select v-model="obj.selectedRangeValue" @change="handleSelectDayChange" style="width:120px">
              <el-option v-for="item in obj.selectRangeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="因变量">
            <el-input v-model="obj.searchValue" placeholder="个股 名称/代码" @input="handleInput" style="width: 250px"
              clearable>
              <template #prefix>
                <el-icon class="el-input__icon">
                  <search />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="自变量">
            <el-input v-model="obj.searchValue2" placeholder="市场指数 名称/代码 上证 深证" @input="handleInput2" style="width: 250px" clearable>
              <template #prefix>
                <el-icon class="el-input__icon">
                  <search />
                </el-icon>
              </template>
            </el-input>
          </el-form-item> -->
          <el-form-item label="自变量">
            <el-select v-model="obj.searchValue2" @change="handleSearchValue2Change" style="width:120px">
              <el-option v-for="item in obj.searchList2" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="handleSubmit">
              <el-icon class="el-input__icon">
                <refresh />
              </el-icon>
            </el-button>
          </el-form-item>
        </el-space>
      </div>
    </el-form>
    <!-- <div class="pt-16">
      <el-space v-for="data in obj.symbolList" :key="data">
        <el-form-item label="">
          <el-input v-model="data.name" :disabled="true" style="width:80px;color:red" />
          <el-button type="danger" @click="del(data)">删除</el-button>
        </el-form-item>
      </el-space>
    </div> -->
    <div style="width: 250px; max-height: 420px;" class='search-ul'>
      <div v-for="data in obj.filteredList" :key="data" class="search-li" @click="handleClick(data)">
        {{ data['name'] }} {{ data['symbol'] }}
      </div>
    </div>
    <div style="width: 250px; max-height: 420px;" class='search-ul2'>
      <div v-for="data in obj.filteredList2" :key="data" class="search-li2" @click="handleClick2(data)">
        {{ data['name'] }} {{ data['symbol'] }}
      </div>
    </div>
    <el-table :data="obj.dataList" style="width: 100%" height="100%" empty-text=" "
      :style="'height:' + (store.state.windowHeight - 240) + 'px'" :cell-style="cellStyle" @row-click="handleRowClick">
      <el-table-column fixed label="序号" prop="no" width="60px" align="right" />
      <el-table-column label="日期" prop="date" width="200px" align="right" sortable />
      <el-table-column label="因变量" prop="y" width="110px" align="right" sortable />
      <el-table-column label="自变量" prop="x" width="110px" align="right" />
      <el-table-column label="相关系数" prop="c" width="110px" align="right" sortable />
      <el-table-column label="拟合系数" prop="f" width="110px" align="right" sortable />
      <el-table-column label="alpha值" prop="a" width="110px" align="right" sortable />
      <el-table-column label="beta值" prop="b" width="110px" align="right" sortable />
      <el-table-column label="理论价" prop="llj" width="110px" align="right" sortable />
      <el-table-column label="最新价" prop="zxj" width="110px" align="right" sortable />
      <el-table-column label="偏差" prop="diff" width="110px" align="right" sortable />
      <el-table-column label="偏差%" prop="diff2" width="110px" align="right" sortable />
      <!-- <el-table-column label="t值" prop="t"  width="120px" align="right" /> -->
      <!-- <el-table-column label="回归方程" prop="r" width="200px" align="right" sortable/> -->
    </el-table>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { http } from "../util/http";
import { ElMessage } from 'element-plus'
import { findObjByField } from '../util/base'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const chartDomRef = ref()
    const obj = reactive({
      searchList: [],
      // searchList2: [],
      filteredList: [],
      // filteredList2: [],
      searchValue: '',
      // searchValue2: '',
      searchSymbol: '',
      // searchSymbol2: '',
      selectRangeList: [
        {
          value: '20',
          label: '最近 20日'
        },
        {
          value: '40',
          label: '最近 40日'
        },
        {
          value: '60',
          label: '最近 60日'
        },
        // {
        //   value: '120',
        //   label: '最近 120日'
        // }
      ],
      selectedRangeValue: '60',
      searchList2: [
        {
          value: '999999',
          label: '上证指数'
        },
        // {
        //   value: '399001',
        //   label: '深证指数'
        // },
      ],
      searchValue2: '上证指数',
      searchSymbol2: '999999',
      dataList: [],
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      vueEvent.emit('navbarMenuIdxEvent', '8')
      vueEvent.emit('sidebarMenuIdxEvent', '')
      renderView()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.regressionData === '') {
        // 无缓存，从后台请求数据
        renderSelect()
      } else {
        // 有缓存，设定页面状态
        getStore()
      }
    }

    // 获取数据渲染下拉框
    const renderSelect = () => {
      let formData = new FormData()
      formData.append("category", "all")
      formData.append("page", 1)
      formData.append("limit", "10000")
      http({
        url: `/market`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data.data)
        obj.searchList = res.data.data.data
        // obj.searchList2 = [{ symbol: '999999', name: '上证指数' }, { symbol: '399001', name: '深证指数' }]
      })
    }

    // 搜索框输入事件(因变量)
    const handleInput = () => {
      if (obj.searchValue.trim() === '') {
        obj.filteredList = []
        return
      }
      obj.filteredList = obj.searchList.filter(item => item['name'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()) ||
        item['symbol'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()))
    }

    // 搜索框输入事件(自变量)
    const handleInput2 = () => {
      // if (obj.searchValue2.trim() === '') {
      //   obj.filteredList2 = []
      //   return
      // }
      // obj.filteredList2 = obj.searchList2.filter(item => item['name'].toUpperCase().includes(obj.searchValue2.trim().toUpperCase()) ||
      //   item['symbol'].toUpperCase().includes(obj.searchValue2.trim().toUpperCase()))
    }

    // 搜索结果点击事件(因变量)
    const handleClick = (data) => {
      obj.searchValue = data['name']
      obj.searchSymbol = data['symbol']
      obj.filteredList = []
    }

    // 搜索结果点击事件(自变量)
    const handleClick2 = (data) => {
      // obj.searchValue2 = data['name']
      // obj.searchSymbol2 = data['symbol']
      // obj.filteredList2 = []
    }

    // 页面空白点击事件
    const handlePageClick = () => {
      obj.filteredList = []
      // obj.filteredList2 = []
    }

    // 表单check
    const formCheck = () => {
      // if (obj.searchValue.trim() === "" || obj.searchValue2.trim() === "") {
      //   ElMessage.error('请选择两个需要回归的合约')
      //   return false
      // }
      if (obj.searchValue.trim() === "") {
        ElMessage.error('请选择需要回归的个股')
        return false
      }
      if (obj.searchValue.trim() === obj.searchValue2.trim()) {
        ElMessage.error('两个合约不能相同')
        return false
      }
      return true
    }

    // 提交处理
    const handleSubmit = () => {
      if (!formCheck()) {
        return
      }
      let formData = new FormData()
      formData.append("name_x", obj.searchSymbol2)
      formData.append("name_y", obj.searchSymbol)
      formData.append("interval", obj.selectedRangeValue)
      http({
        url: `/regression`,
        method: 'post',
        data: formData
      }).then((res) => {
        processData(res)
        setStore()
      })
    }

    // 后台获取数据
    const processData = (res) => {
      console.log(res.data)
      let no = 1
      res.data.data.forEach((item) => {
        if (item.chgPct !== "-") {
          item.date = item['日期']
          item.y = obj.searchValue
          item.x = obj.searchValue2
          item.c = item['相关系数']
          item.f = item['拟合系数']
          item.a = item['alpha值']
          item.b = item['beta值']
          item.t = item['t值']
          item.r = item['回归方程']
          item.llj = item['理论价']
          item.zxj = item['最新价']
          item.diff = item['偏差']
          item.diff2 = item['%']
        }
        item.no = no
        no++
      })
      obj.dataList = res.data.data
      // obj.dataList.push(res.data.data[0])
    }

    // 下拉框选择事件
    const handleSelectDayChange = (value) => {
      // handleSubmit()
    }

    // 自变量选择事件
    const handleSearchValue2Change = (value) => {
      let tempObj = findObjByField(obj.searchList2, 'value', obj.searchValue2)
      obj.searchValue2 = tempObj.label
      obj.searchSymbol2 = value
    }

    // 保存至store
    const setStore = () => {
      var storeObj = {
        'searchList': obj.searchList,
        'searchList2': obj.searchList2,
        'filteredList': obj.filteredList,
        // 'filteredList2': obj.filteredList2,
        'searchValue': obj.searchValue,
        'searchValue2': obj.searchValue2,
        'searchSymbol': obj.searchSymbol,
        'searchSymbol2': obj.searchSymbol2,
        'selectedRangeValue': obj.selectedRangeValue,
        'dataList': obj.dataList,
      }
      store.commit('setRegressionData', storeObj) // 缓存数据
    }

    // 获取Store
    const getStore = () => {
      obj.searchList = store.state.regressionData.searchList
      obj.searchList2 = store.state.regressionData.searchList2
      obj.filteredList = store.state.regressionData.filteredList
      // obj.filteredList2 = store.state.regressionData.filteredList2
      obj.searchValue = store.state.regressionData.searchValue
      obj.searchValue2 = store.state.regressionData.searchValue2
      obj.searchSymbol = store.state.regressionData.searchSymbol
      obj.searchSymbol2 = store.state.regressionData.searchSymbol2
      obj.selectedRangeValue = store.state.regressionData.selectedRangeValue
      obj.dataList = store.state.regressionData.dataList
    }

    return {
      obj,
      store,
      chartDomRef,
      handleInput,
      handleInput2,
      handleClick,
      handleClick2,
      handlePageClick,
      handleSubmit,
      handleSelectDayChange,
      handleSearchValue2Change
    }
  }
}
</script>
<style lang="scss" scoped>
/* ================================
Components
Search
================================= */
.search-ul {
  position: absolute;
  left: 260px;
  top: 100px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}

.search-li {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}

.search-li:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}

.search-ul2 {
  position: absolute;
  left: 570px;
  top: 100px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}

.search-li2 {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}

.search-li2:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
</style>
